export default __webpack_public_path__ + "3b3df8c4634b8630bf410a98d2e18e3e.png";